<template>
	<div class="fwd-cku-test__btns">
		<!-- 저장 -->
		<sf-button v-if="isButton_(scrId, 'CC') && showSaveBtn" line icon="file" :onClick="() => saveAction('save')">
			{{ getMessage_('QWCC001131') }}
		</sf-button>
		<!--  작성 -->
		<!-- <sf-button v-if="isButton_(scrId, 'CU') && showRegBtn" line icon="sub-menu-off" :onClick="() => saveAction('register')">
			{{ getMessage_('QWCC000056') }}
		</sf-button> -->
		<!--  수정 -->
		<sf-button v-if="isButton_(scrId, 'CU') && showRenewBtn" line icon="sub-menu-off" :onClick="renew">
			{{ getMessage_('QWCC001945') }}
		</sf-button>
		
		
	</div>
</template>

<script>
import * as Yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { },
	methods: {
		...rootMethods,
		...serviceMethods,
		async renew() {
			try {
				// this.schemaSave.validateSync(this.selectedRow);
				this.setPopupSearchParam_({ key: 'saveStatus', value: 'renew' });
				await this.refresh();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.setPopupSearchParam_({ key: 'saveStatus', value: '' });
				this.setState_({key: 'readOnlyAuth', value: false});
			}
		},
		saveAction(flag) {
			try {
				if (flag === 'register') {
					this.schemaSave.validateSync(this.selectedRow);
					this.validateTableList();
					// this.checkDataConsistency();
				}
				this.$sf_showMessage({
						type: 'confirm',
						icon: 'confirm',
						message: flag === 'save' ? this.getMessage_('QWCC001119') : this.getMessage_('QWCC001794'),
						buttons: [{ title: 'Ok', clickFn: () => this.save(flag) }]
					});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		async save(flag) {
			try {
				this.$sf_toggleLoading(true);
				// this.setSelectedRow_({
				// 	key: 'erpSaleDd',
				// 	value: this.$moment(this.selectedRow.erpSaleDd).format('YYYYMMDD')
				// }); //정비시작일
				// this.setSelectedRow_({
				// 	key: 'oemSaleDd',
				// 	value: this.$moment(this.selectedRow.oemSaleDd).format('YYYYMMDD')
				// });
				this.setSelectedRow_({ key: 'saveStatus', value: flag });
				const { data } = await this.saveData_(this.getFormDatas_);
				const { code, messageCd } = data.header;
				if (code == 0 || code == 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
				code === 0 && this.refresh();
				this.setState_({ key: 'readOnlyAuth', value: true });
			} catch (error) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001402') });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		/** 저장 후 새로고침 */
		async refresh() {
			this.$sf_toggleLoading(true);
			try {

				await this.getPopupList_();
				this.setPopupSearchParam_({ key: 'ipnNos', value: this.selectedRow.ipnNos });
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		validateTableList() {
			for (const tableRow of this.resultList) {
				// if (!tableRow.prvsRsltCd) {
				// 	throw new Error(this.getMessage_('QWCC001990')); //표에 작성하지 않은 결과가 있습니다. 모든 결과를 입력해야 작성 완료됩니다.
				// } else continue;
			}
		},
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		showSaveBtn() {
			return this.popupSearchParams.pmcId && this.popupSearchParams.ipnNos && !this.readOnlyAuth;
		},
		showRegBtn() {
			return this.showSaveBtn;
		},
		showRenewBtn() {
			return this.popupSearchParams.pmcId && this.readOnlyAuth;
		},
		// showChangeBtn() {
		// 	return this.hasChanged_ && this.showRenewBtn;
		// },
		
		schemaSave() {
			return Yup.object().shape({
				wrntStrtDd: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001092')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001092')])),
				
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.fwd-cku-test__btns {
	height: 43px;
}
</style>
